import {Box, BoxProps} from '@chakra-ui/react';
import React from 'react';

const defaultSize = {
  xs: {width: 2},
  sm: {width: 6},
  md: {width: 10},
  xl: {width: 14},
  xll: {width: 18},
};

type Props = {
  mode?: 'horizontal' | 'vertical';
  size?: keyof typeof defaultSize | number;
};
/**
 * Vertical | Horizontal spacer
 * @property mode - default [vertical]
 * @property size - default [sm]
 *
 */
export const SpacerUI = ({mode, size = 'sm'}: Props) => {
  const styles: BoxProps = {};
  if (mode === 'horizontal') {
    styles.width = `${typeof size === 'number' ? size : defaultSize[size].width}px`;
  } else {
    styles.height = `${typeof size === 'number' ? size : defaultSize[size].width}px`;
  }
  return <Box {...styles} />;
};
